import { render, staticRenderFns } from "./DataManagerView.vue?vue&type=template&id=804a1292"
import script from "./DataManagerView.vue?vue&type=script&lang=js"
export * from "./DataManagerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports